import { render } from "./PlanosView.vue?vue&type=template&id=6c609284&scoped=true"
import script from "./PlanosView.vue?vue&type=script&lang=js"
export * from "./PlanosView.vue?vue&type=script&lang=js"

import "./PlanosView.vue?vue&type=style&index=0&id=6c609284&scoped=true&lang=css"
import "./PlanosView.vue?vue&type=style&index=1&id=6c609284&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c609284"]])

export default __exports__